var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNfts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    fill: "none",
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.8039 0.85471c-0.76878 0-1.5061 0.30539-2.0497 0.849-0.54361 0.54361-0.849 1.2809-0.849 2.0496v14.493c0 0.76878 0.30539 1.506 0.849 2.0496 0.54361 0.5436 1.2809 0.84904 2.0497 0.84904h17.392c0.76878 0 1.506-0.30545 2.0496-0.84904 0.54368-0.54359 0.84904-1.2809 0.84904-2.0496v-14.493c0-0.76877-0.30536-1.506-0.84904-2.0496-0.5436-0.54361-1.2809-0.849-2.0496-0.849zm17.392 17.392h-17.392l5.7973-11.594 4.348 8.6961 2.8987-5.7973z",
    clipRule: "evenodd",
    fill: "#06d6a0",
    fillRule: "evenodd",
    strokeWidth: 0.90584
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfts);
export default __webpack_public_path__ + "static/media/nfts.dd9bfc997e1b37de670112f383dae828.svg";
export { ForwardRef as ReactComponent };